import {useEffect} from "react";

import useAsyncProcess from "../../../core/network/async-process/useAsyncProcess";
import Fetcher from "../../../core/network/fetcher/Fetcher";
import {ASSET_LOGO_BASE_URL} from "../../util/assetConstants";
import {AssetIconsJSON} from "../../util/assetModels";

function useFetchAssetIcons() {
  const {state, runAsyncProcess} = useAsyncProcess<AssetIconsJSON>({
    initialState: {
      isRequestFetched: false,
      isRequestPending: false,
      error: null,
      data: {}
    }
  });

  useEffect(() => {
    runAsyncProcess(
      new Fetcher({
        baseUrl: ASSET_LOGO_BASE_URL
      }).run<AssetIconsJSON>(
        {
          method: "GET"
        },
        "/icons.json"
      )
    );
  }, [runAsyncProcess]);

  return state;
}

export default useFetchAssetIcons;
